import { useRef, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export default function NotFound() {
  const navigate = useNavigate()
  const location = useLocation()
  const navigateRef = useRef(navigate)

  useEffect(() => {
    navigateRef.current(`/p/error?type=404&path=${location.pathname}`)
  }, [location.pathname])

  return null
}
